import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import { siteConfig } from '@/constants/site'

interface LocalTimeProps {
    className?: string
}

/** Live clock for Fort Worth. Renders a stable placeholder on the server and fills in after mount. */
export const LocalTime: FC<LocalTimeProps> = ({ className }): ReactNode => {
    const [time, setTime] = useState<string | null>(null)

    useEffect(() => {
        const formatter = new Intl.DateTimeFormat('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            timeZone: siteConfig.timeZone
        })

        const update = () => setTime(formatter.format(new Date()))

        update()

        const timer = window.setInterval(update, 15000)

        return () => window.clearInterval(timer)
    }, [])

    return (
        <span className={className}>
            <span className='sr-only'>Local time in Fort Worth: </span>
            <span aria-hidden={time === null}>{time ?? '--:--'}</span>
        </span>
    )
}
